<template>
  <div class="flex w-full">
    <div
      class="bg-grayscale-13 rounded-l-4 text-grayscale-96 flex items-center shrink-0 h-50px px-5"
    >
      <i :class="`icon-${icon} text-20 leading-5`" /><span
        class="ml-3 text-14 leading-5 font-semibold"
        >{{ label }}</span
      >
    </div>
    <input-field
      v-model:value="inputValue"
      :name="icon"
      label-class="mb-2 font-14 text-manatee"
      full-container-class="w-available"
      input-class="border-l-0 rounded-l-none h-50px"
      :is-disabled="loading"
      @clearError="clearError"
      @input="validateProSocialLink()"
      @proceed="checkInput"
      v-model:errorMessage="_errorMessage"
    />
  </div>
</template>

<script setup lang="ts">
import type { SocialLink } from "@/types/user";
import InputField from "@/components/layout/inputs/InputField.vue";

const props = defineProps({
  value: {
    type: String,
    required: true,
  },
  provider: {
    type: String as PropType<SocialLink>,
    required: true,
  },
  isPro: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  errorMessage: {
    type: String,
    default: "",
  },
});

const inputValue = ref(props.value);

const emit = defineEmits([
  "proceed",
  "clearError",
  "update:value",
  "update:errorMessage",
]);

const _errorMessage = computed({
  get() {
    return props.errorMessage;
  },
  set(value) {
    emit("update:errorMessage", value);
  },
});

const clearError = () => {
  emit("clearError");
};

const checkInput = () => {
  emit("proceed");
};

const validateProSocialLink = () => {
  try {
    emit("clearError");
    emit(
      "update:value",
      validateSocialLink(inputValue.value, props.provider, props.isPro),
    );
  } catch (error: any) {
    _errorMessage.value = error.message;
  }
};

watch(
  () => props.value,
  (value) => {
    inputValue.value = value;
  },
);
// migration for links
// TODO: remove after migration
// [
//   {
//     $addFields: {
//       socialLinks: {
//         $arrayToObject: {
//           $map: {
//             input: {
//               $objectToArray: "$socialLinks",
//             },
//             in: {
//               k: "$$this.k",
//               v: {
//                 $cond: {
//                   if: {
//                     $eq: [
//                       {
//                         $substr: [
//                           "$$this.v",
//                           0,
//                           1,
//                         ],
//                       },
//                       "@",
//                     ],
//                   },
//                   then: {
//                     $substr: [
//                       "$$this.v",
//                       1,
//                       {
//                         $strLenCP: "$$this.v",
//                       },
//                     ],
//                   },
//                   else: "$$this.v",
//                 },
//               },
//             },
//           },
//         },
//       },
//     },
//   },
//   {
//     $merge: {
//       into: "users",
//       on: "_id",
//       whenMatched: "replace",
//       whenNotMatched: "fail",
//     },
//   },
// ]
</script>
